import React from "react";
import { MessageCircle } from "lucide-react";

export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0B0F19]/95 backdrop-blur-xl border-t border-white/10 px-4 py-3 flex items-center gap-2"
    >
      <a
        href="https://wa.me/17865756919?text=Hi%21%20I%27d%20like%20to%20learn%20about%20the%20website%20special."
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-sticky-whatsapp-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white font-bold py-3 text-sm shadow-lg active:scale-[0.98]"
      >
        <MessageCircle size={18} /> Message Us Now
      </a>
      <a
        href="#contact"
        data-testid="mobile-sticky-claim-btn"
        className="flex-1 inline-flex items-center justify-center rounded-full bg-yellow-400 text-slate-900 font-bold py-3 text-sm active:scale-[0.98]"
      >
        Claim Offer
      </a>
    </div>
  );
}
